
    import './styles.scoped.css';
    export default {
  "trigger-label": "awsui_trigger-label_q2oen_w271r_5",
  "menu-item": "awsui_menu-item_q2oen_w271r_6",
  "main-action-label": "awsui_main-action-label_q2oen_w271r_7"
};
  